import { supabase } from './lib/supabase';

const TABLE_MAP = {
  patients: 'clients',
  suppliers: 'suppliers',
  products: 'products',
  treatments: 'treatments',
  prescriptions: 'prescriptions',
  stock: 'stock',
  todos: 'todos',
  fridgeChecks: 'fridge_checks',
  orders: 'todos',
};

export const STORES = {
  patients: 'patients',
  suppliers: 'suppliers',
  products: 'products',
  treatments: 'treatments',
  prescriptions: 'prescriptions',
  stock: 'stock',
  todos: 'todos',
  fridgeChecks: 'fridgeChecks',
  orders: 'orders',
};

const tbl = (store) => TABLE_MAP[store] || store;

export const initDB = () => Promise.resolve();

export const getAll = async (store) => {
  const { data, error } = await supabase
    .from(tbl(store))
    .select('*')
    .order('created_at', { ascending: false });
  if (error) { console.error('getAll error:', error); return []; }
  return data || [];
};

export const add = async (store, item) => {
  const { id: _id, created_at, updated_at, ...rest } = item;
  const { data, error } = await supabase
    .from(tbl(store))
    .insert([rest])
    .select()
    .single();
  if (error) throw error;
  return data.id;
};

export const update = async (store, item) => {
  const { id, created_at, ...rest } = item;
  const { error } = await supabase
    .from(tbl(store))
    .update({ ...rest, updated_at: new Date().toISOString() })
    .eq('id', id);
  if (error) throw error;
};

export const remove = async (store, id) => {
  const { error } = await supabase.from(tbl(store)).delete().eq('id', id);
  if (error) throw error;
};

export const exportData = async () => {
  const data = {};
  for (const [store, table] of Object.entries(TABLE_MAP)) {
    const { data: rows } = await supabase.from(table).select('*');
    data[store] = rows || [];
  }
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `DA-Hub-Backup-${new Date().toISOString().split('T')[0]}.json`;
  a.click();
  URL.revokeObjectURL(url);
};
